import { getTxtIdMapperPath } from "../../router/txtIdMapper";
import { apiS } from "./api-base"
import { getESGReqHeader } from "./tool-service";


// 文件資訊列表查詢
export const queryCompaniesFilesList = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1040101'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F1040101")}`, method: 'post', data: ReqBody })
}

// 文件資訊列表新增
export const createCompaniesFilesList = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1040102'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F1040102")}`, method: 'post', data: ReqBody })
}

// 文件資訊列表更新
export const updateCompaniesFilesList = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1040103'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F1040103")}`, method: 'post', data: ReqBody })
}

// 文件資訊列表刪除
export const deleteCompaniesFilesList = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1040104'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F1040104")}`, method: 'post', data: ReqBody })
}